import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const SidebarPageContext = /*#__PURE__*/createContext(undefined);
export const SidebarPageProvider = ({
  abstractPageGridContentStylesOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(SidebarPageContext.Provider, {
    value: {
      abstractPageGridContentStylesOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `SidebarPage` component.
 * Note: The context is only available when the `SidebarPage` component is rendered as an ancestor.
 * @returns SidebarPageContext - The context for the `SidebarPage` component.
 * @returns SidebarPageContext.abstractPageGridContentStylesOverrides - Style overrides to be applied to the `AbstractPageGridContent` component.
 */
export const useSidebarPageContext = () => {
  const sidebarPageContext = useContext(SidebarPageContext);
  return sidebarPageContext;
};